import { StatCard } from "../shared/StatCard";

interface PointsDashboardProps {
  formattedPoints: string;
  formattedVoid: string;
  shipCount: number;
}

export function PointsDashboard({
  formattedPoints,
  formattedVoid: _formattedVoid,
  shipCount: _shipCount,
}: PointsDashboardProps) {
  const displayPoints = Number.parseFloat(formattedPoints).toFixed(4);

  return (
    <div className="points-dashboard">
      <StatCard label="PTS" value={displayPoints} icon="⭐" accent="var(--color-cyan)" />
    </div>
  );
}
